document.addEventListener('DOMContentLoaded', function () {
    let intervalCustom;

    console.log('entro aqui')

    intervalCustom = setInterval(() => {
        if (document.readyState === "complete") {
            let valor = window.metaDataVariant.deliverysDays;
            var fromDate2 = Date.today();

            var options = { month: 'long', day: 'numeric' };
            for (var i = 1; i <= valor; i++) {
                fromDate2 = Date.today().addDays(i);
                if (fromDate2.is().saturday() || fromDate2.is().sunday()) {
                    valor++;
                }
            }
            var newvalor = valor;
            var fromDate2 = Date.today().addDays(valor);

            var toDate2 = Date.today().addDays(newvalor + 1);
            if (toDate2.is().saturday() || toDate2.is().sunday()) {
                toDate2 = toDate2.next().monday();
            }
            document.getElementById('toDate2').innerHTML = fromDate2.toLocaleString(undefined, options);
            document.getElementById('fromDate2').innerHTML = toDate2.toLocaleString(undefined, options);
            clearInterval(intervalCustom);
        }
    }, 100);
});